import { FC, memo, useMemo } from 'react';
import { Project } from "@brg/api";
import { FlexBox, useBreakpoint } from "@brg/ui";
import BookmarkButton from "../bookmarkButton/bookmarkButton";
import { LikesController } from "../../../core/modules/likes.module";
import { AppTester } from 'supporting';
import ProjectButtons from "../../pages/project/components/ProjectButtons";
import ShareButton from '../ShareButton/ShareButton';
import { useRouteMatch } from 'react-router-dom';
import styled, { css } from 'styled-components';

type PropsT = {
  project: Project;
  isModer?: boolean;
  setMobileOffset?: (val: number) => void;
};

const StickyWrapper = styled(FlexBox)<{ inActiveState?: boolean }>`
  ${({ inActiveState }) => inActiveState ? css`
  * {
    cursor: not-allowed;
    pointer-events: none;
  }
  ` : null};
`;

const StickyActionBar: FC<PropsT> = ({ project, isModer, setMobileOffset }) => {
  const isOnlines = AppTester.isOnlines();
  const isPreview = !!useRouteMatch(['/preview', '/book-preview']);
  const isMobile = useBreakpoint(945)

  const inActiveState = useMemo(() => !!isPreview, [isPreview]);

  return (
    <StickyWrapper width="100%" justifyMobile="space-between" justify="flex-end" inActiveState={inActiveState}>
      <ProjectButtons isProjectButtons project={project}/>
      {!isMobile &&
        <BookmarkButton
          project={project}
          entityId={project.projectId}
          entityType="project"
          inActiveState={inActiveState}
        />
      }
      {isOnlines ? (
        <ShareButton project={project}/>
      ) : (
          <ShareButton project={project} showLikeDropdown inActiveState={inActiveState} setMobileOffset={setMobileOffset} />
      )}
      {!isOnlines && (
        <LikesController
          entityId={project.projectId}
          entityType="project"
          inActiveState={inActiveState}
        />
      )}
    </StickyWrapper>
  )
};

export default memo(StickyActionBar)

import { FC, memo, useMemo } from 'react';
import { Project } from "@brg/api";
import { FlexBox, useBreakpoint } from "@brg/ui";
import BookmarkButton from "../bookmarkButton/bookmarkButton";
import { LikesController } from "../../../core/modules/likes.module";
import { AppTester } from 'supporting';
import ProjectButtons from "../../pages/project/components/ProjectButtons";
import ShareButton from '../ShareButton/ShareButton';
import { useRouteMatch } from 'react-router-dom';
import styled, { css } from 'styled-components';

type PropsT = {
  project: Project;
  isModer?: boolean;
  setMobileOffset?: (val: number) => void;
};

const StickyWrapper = styled(FlexBox)<{ inActiveState?: boolean }>`
  ${({ inActiveState }) => inActiveState ? css`
  * {
    cursor: not-allowed;
    pointer-events: none;
  }
  ` : null};
`;

const StickyActionBar: FC<PropsT> = ({ project, isModer, setMobileOffset }) => {
  const isOnlines = AppTester.isOnlines();
  const isPreview = !!useRouteMatch(['/preview', '/book-preview']);
  const isMobile = useBreakpoint(945)

  const inActiveState = useMemo(() => !!isPreview, [isPreview]);

  return (
    <StickyWrapper width="100%" justifyMobile="space-between" justify="flex-end" inActiveState={inActiveState}>
      <ProjectButtons isProjectButtons project={project}/>
      {!isMobile &&
        <BookmarkButton
          project={project}
          entityId={project.projectId}
          entityType="project"
          inActiveState={inActiveState}
        />
      }
      {isOnlines ? (
        <ShareButton project={project}/>
      ) : (
          <ShareButton project={project} showLikeDropdown inActiveState={inActiveState} setMobileOffset={setMobileOffset} />
      )}
      {!isOnlines && (
        <LikesController
          entityId={project.projectId}
          entityType="project"
          inActiveState={inActiveState}
        />
      )}
    </StickyWrapper>
  )
};

export default memo(StickyActionBar)

